import { Injectable } from '@angular/core';
import { SharedDataService } from '../all-services';
import {
  Profil,
  SupplierStatut,
  SimpleReponseResult,
  ContactStoredData
} from '../all-models';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Ps_LstPerimeters_XRP_Result } from '../Models/Ps_LstPerimeters_XRP_Result';

@Injectable({
  providedIn: 'root'
})
export class LoggedUserService {
  loggedUserUrl: string 

  constructor(public sharedDataSvc: SharedDataService, private http: HttpClient) {
    this.loggedUserUrl = this.sharedDataSvc.apiBaseUrl + 'LoggedUser/';
  }


  public Profil(): Observable<Profil> {
    return this.http.get<Profil>(this.loggedUserUrl + 'Profil');
  }

  public VisibleSupplierStatuts(): Observable<SupplierStatut[]> {
    return this.http.get<SupplierStatut[]>(this.loggedUserUrl + 'VisibleSupplierStatuts');
  }


  StoreDatas(key: string, value: any): Observable<SimpleReponseResult> {
    if (!this.sharedDataSvc.loggedContact?.Id) {
      let simpleReponseResult: SimpleReponseResult = new SimpleReponseResult();
      simpleReponseResult.Id = 0;
      simpleReponseResult.Ok = false;
      simpleReponseResult.Message = "Utilisateur non connecté";
      return of(simpleReponseResult);
    } else {
      let parameters: ContactStoredData = new ContactStoredData();
      parameters.ContactId = this.sharedDataSvc.loggedContact.Id;
      parameters.Key = key;
      parameters.Datas = JSON.stringify(value, null, 3);
      return this.http.post<SimpleReponseResult>(`${this.loggedUserUrl}StoreDatas`, parameters);
    }
  }

  LoggedUserStoredDatas(): Observable<ContactStoredData[]> {
    if (!this.sharedDataSvc.loggedContact?.Id) {
      return of([]);
    } else {
      return this.http.get<ContactStoredData[]>(`${this.loggedUserUrl}StoredDatas`);
    }
  }

  public LstPerimeters(): Observable<Ps_LstPerimeters_XRP_Result[]> {
   return this.http.get<Ps_LstPerimeters_XRP_Result[]>(`${this.loggedUserUrl}LstPerimeters`);
  }

  
}
